export class ReturnReceiveItem {
  Line: string;
  ItemCode: { imgSrc: string; text: string };
  ItemDescription: string;
  UOM: string;
  ExpectedQty: string;
  BackorderQty: string;
  ReceivedQuantity: string;
  constructor() {
    this.Line = "";
    this.ItemCode = {
      imgSrc: "",
      text: "",
    };
    this.ItemDescription = "";
    this.UOM = "";
    this.ExpectedQty = "";
    this.BackorderQty = "";
    this.ReceivedQuantity = "";
  }
}
